import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractHttpService } from '../../service/http-abstract-service';
import { AuditDataDto, AuditProcessRequestTypeEnum, FailedTxDto, KioskAuditDto, ReportDayEndDto, ReportDto } from './dto';


@Injectable({
	providedIn: 'root'
})
export class HttpKioskAuditsService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/audits');
	}

	getAll(from: Date, to: Date, process: AuditProcessRequestTypeEnum, kioskId: number): Observable<KioskAuditDto> {
		var search = {
			from: from, 
			to: to, 
			process: process, 
			kioskId: kioskId
		}
		return super.post(`/get`, search);
	}
}
